import { Component, OnInit } from '@angular/core';
import { NavbarService } from './navbar.service';
import {LocalStorageService} from 'ng2-webstorage';
import {Router} from '@angular/router';
import {AppConstants} from '../../app.constants';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  schoolLogo: any;
  imgUrl: any;
  public schoolid: any;


  public showNav = false;
  public parent_email: string = "";

  isStudentDetailsExpanded: boolean = false;
  isManageUserExpanded: boolean = false;
  isTeacherDetailsExpanded: boolean = false;
  isQuantaIntelligenceExpanded: boolean = false;
  isPaperBankExpanded: boolean = false;



  constructor(public navbarService: NavbarService,
              private localStorage: LocalStorageService,
              private router: Router,
              private appConstants: AppConstants) { }

  ngOnInit() {
    this.schoolLogo = this.localStorage.retrieve("logo");
    this.imgUrl = this.appConstants.fileDownloadUrl;
    this.schoolid = this.localStorage.retrieve('schoolid');

  }

  toggleSubtopics(section: string) {


    if (section === 'student_details') {
      if (this.isStudentDetailsExpanded == false){
        this.isStudentDetailsExpanded = true;
        this.isManageUserExpanded = false;
        this.isTeacherDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isStudentDetailsExpanded = false;
      }
    }
    else if (section === 'manage_user') {
      if (this.isManageUserExpanded == false){
        this.isManageUserExpanded = true;
        this.isTeacherDetailsExpanded = false;
        this.isStudentDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isManageUserExpanded = false;
      }
    }
    else if (section === 'teacher_details') {
      if (this.isTeacherDetailsExpanded == false){
        this.isTeacherDetailsExpanded = true;
        this.isManageUserExpanded = false;
        this.isStudentDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isTeacherDetailsExpanded = false;
      }
    }
    else if (section === 'quanta_intelligence') {
      if (this.isQuantaIntelligenceExpanded == false){
        this.isQuantaIntelligenceExpanded = true;
        this.isTeacherDetailsExpanded = false;
        this.isManageUserExpanded = false;
        this.isStudentDetailsExpanded = false;
      }else {
        this.isQuantaIntelligenceExpanded = false;
      }
    }
    else {
      this.isStudentDetailsExpanded = false;
      this.isManageUserExpanded = false;
      this.isTeacherDetailsExpanded = false;
      this.isQuantaIntelligenceExpanded = false;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }




  nav() {
    if (this.showNav) {
      this.showNav = false;
    }else {
      this.showNav = true;
    }
  }


  logOut(){
    this.localStorage.clear();
    this.router.navigate(["authentication/select-portal"]).then(() => {
      //window.location.reload();
    });
  }


  navigateToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  paperBank(section: string) {
    if (this.isPaperBankExpanded) {
      this.isPaperBankExpanded = false;
    }else{
      this.isPaperBankExpanded = true;
    }
    console.log(this.isPaperBankExpanded);
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/dashboard.component.ts